import { Fragment, FunctionalComponent, h } from "preact";
import { useEffect, useRef, useState, useCallback } from "preact/hooks";
import ReactHlsPlayer from "./react-hls-player-wrapper/dist";
import { isMobileOnly, isIOS } from "react-device-detect";
import style from "./style.css";
import { sendEvent } from "../stats/sendEvent";
import { useAppSelector } from "../../redux/hooks";
import {
  IKorraEventDoc,
  IKorraEventType,
  ISubtitle,
  IVideoText,
} from "../../models/interfaces";

import {
  getIsEdge,
  get_AI_URI_BASE,
  get_CDN_BASE_URL,
  getCdnKorraBaseUrl,
} from "../../configs/env";
import { FileType } from "../../models/enums";
import { getSassToken, removeMultipleSlashes } from "../../utils";
import logger from "../../logger";
const axios = require("axios").default;

interface IKorraVideoPlayerProps {
  companyid?: string;
  workspaceid: string;
  portalid?: string;
  kappid: string;
  workspaceAlias?: string;
  portalAlias?: string;
  guid: string;
  docguid: string;
  muted: boolean;
  autoplay: boolean;
  controls: boolean;
  disableplay?: string;
  jwtUserIdToken?: string;
  userId?: string;
  handleToggleFullScreen?: () => void;
  isMobile?: boolean;
}
const KorraVideoPlayer: FunctionalComponent<IKorraVideoPlayerProps> = (
  props: IKorraVideoPlayerProps
) => {
  let {
    companyid,
    workspaceid,
    portalid,
    kappid,
    guid,
    docguid,
    muted,
    controls,
    jwtUserIdToken,
    userId,
    handleToggleFullScreen,
    isMobile,
  } = props;
  if (muted && muted.toString() === "false") muted = false;
  const appearance = useAppSelector((state) => state.appearance);
  const globals = useAppSelector((state) => state.globals);
  const alias = useAppSelector((state) => state.alias);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [section, setSection] = useState<any>(null);
  const [videoText, setVideoText] = useState<IVideoText | null>(null);
  const [SassToken, setSassToken] = useState<string>("");
  let subtitles: boolean = false;

  (window as any).addEventListener("toggle-subtitles", (event: any) => {
    event?.stopPropagation();
    event?.preventDefault();
    subtitles = !subtitles;
  });

  useEffect(() => {
    if (appearance.isPrivate) {
      if (workspaceid && ((globals.jwtUserIdToken && globals.userId)||getIsEdge())) {
        (async () => {
          try {
            const st = await getSassToken(
              workspaceid,
              portalid || "",
              globals.userId,
              globals.jwtUserIdToken,
              getIsEdge() === true ? true : false
            );
            setSassToken(st);
          } catch (error: any) {
            /** Error type */
            // general error
            logger.error({
              message: "Failed to get SAS token for private workspace",
              error: error,
              stacktrace: error?.stack,
              portal_alias: alias.portalAlias,
            });
          }
        })();
      }
    } else {
      if (workspaceid) {
        (async () => {
          try {
            const st = await getSassToken(
              workspaceid,
              portalid || "",
              globals.userId,
              globals.jwtUserIdToken,
              getIsEdge() === true ? true : false
            );
            setSassToken(st);
          } catch (error: any) {
            /** Error type */
            // general error
            logger.error({
              message: "Failed to get SAS token for public workspace",
              error: error,
              stacktrace: error?.stack,
              portal_alias: alias.portalAlias,
            });
          }
        })();
      }
    }
  }, [
    workspaceid,
    portalid,
    globals.userId,
    globals.jwtUserIdToken,
    appearance.loaded,
    appearance.preview,
  ]);

  useEffect(() => {
    if (videoRef && videoRef.current && section && SassToken) {
      videoRef.current.currentTime =
        section?.action?.imageParams?.video?.tstart;
      videoRef.current.load();
      if (videoRef.current && videoRef.current.readyState >= 2) {
        videoRef.current.play();
      } else {
        videoRef.current.addEventListener(
          "loadeddata",
          () => {
            if (videoRef.current)
              videoRef.current.currentTime =
                section?.action?.imageParams?.video?.tstart;
            videoRef?.current?.play();
          },
          { once: true }
        );
      }
    }
  }, [section, SassToken]);

  useEffect(() => {
    if (!(workspaceid || companyid) || !kappid || !docguid || !guid) return;

    let getVideoSourceUrl =
      get_AI_URI_BASE() +
      `/api/getVideoSources/company/${
        workspaceid || companyid
      }/kapp/${kappid}/video/${docguid}`;
    let getVideoSectionUrl =
      get_AI_URI_BASE() +
      `/api/getVideoSection/company/${
        workspaceid || companyid
      }/kapp/${kappid}/video/${guid}`;
    getVideoSectionUrl = getVideoSectionUrl.split("&")[0];
    getVideoSourceUrl = getVideoSourceUrl.split("&")[0];

    let headers = {
      headers: {
        Authorization: `Bearer ${jwtUserIdToken}`,
        "User-Id": userId,
        " Portal-Id": portalid,
      },
    };
    axios
      .all([
        axios.get(getVideoSourceUrl, headers),
        axios.get(getVideoSectionUrl, headers),
      ])
      .then(
        axios.spread((...responses: any) => {
          let getVideoSourceResponse = responses[0];
          let getVideoSectionResponse = responses[1];
          // use/access the results
          try {
            for (
              let sourceIndex = 0;
              sourceIndex < getVideoSourceResponse.data.sources.length;
              sourceIndex++
            ) {
              // remove multiple slashes from url
              getVideoSourceResponse.data.sources[sourceIndex].url =
                getVideoSourceResponse.data.sources[sourceIndex].url.replace(
                  /([^:]\/)\/+/g,
                  "$1"
                );
              // update getVideoSourceResponse.data.sources.url with proxy url
              if (get_CDN_BASE_URL()) {
                let currentUrl2 =
                  getVideoSourceResponse.data.sources[sourceIndex].url;
                let url = new URL(currentUrl2);
                let CDN_BASE_URL = new URL(get_CDN_BASE_URL() || "");
                url.protocol = CDN_BASE_URL.protocol;
                url.host = CDN_BASE_URL.host;
                url.pathname = CDN_BASE_URL.pathname + url.pathname;
                // remove duplicate production segments (with or without slash between)
                url.pathname = url.pathname.replace(/\/production\/?production\//g, '/production/');

                getVideoSourceResponse.data.sources[sourceIndex].url =
                  url.toString();
              }
            }
            // update getVideoSectionResponse.data[0]._source.srcUrl with proxy url
            let currentUrl = getVideoSectionResponse.data[0]._source.srcUrl;
            currentUrl = currentUrl.replace(/([^:]\/)\/+/g, "$1");
            let url = new URL(currentUrl);
            let CDN_BASE_URL = new URL(get_CDN_BASE_URL() || "");
            url.protocol = CDN_BASE_URL.protocol;
            url.host = CDN_BASE_URL.host;
            url.pathname = CDN_BASE_URL.pathname + url.pathname;
            // remove duplicate production segments (with or without slash between)
            url.pathname = url.pathname.replace(/\/production\/?production\//g, '/production/');
            getVideoSectionResponse.data[0]._source.srcUrl = url.toString();
          } catch (error: any) {
            // console.log(error?.message);
          }

          if (getVideoSourceResponse?.data?.sources?.length > 1) {
            let m3u8 = "";
            if (
              getVideoSourceResponse.data.sources[0].url.split(".").pop() ===
              "m3u8"
            ) {
              m3u8 = getVideoSourceResponse.data.sources[0].url;
            } else if (
              getVideoSourceResponse.data.sources[1].url.split(".").pop() ===
              "m3u8"
            ) {
              m3u8 = getVideoSourceResponse.data.sources[1].url;
            }

            let mp4 = "";
            if (
              getVideoSourceResponse.data.sources[0].url.split(".").pop() ===
              "mp4"
            ) {
              mp4 = getVideoSourceResponse.data.sources[0].url;
            } else if (
              getVideoSourceResponse.data.sources[1].url.split(".").pop() ===
              "mp4"
            ) {
              mp4 = getVideoSourceResponse.data.sources[1].url;
            }

            // replace # with %23
            m3u8 = m3u8.replace("#", "%23");
            mp4 = mp4.replace("#", "%23");

            getVideoSectionResponse.data[0]._source.srcUrl = m3u8 || mp4;
            if (getIsEdge())
              getVideoSectionResponse.data[0]._source.srcUrl = mp4;

            (window as any).dispatchEvent(
              new CustomEvent("korra-file-name", {
                detail: mp4.split("/").pop(),
              })
            );
          } else {
            (window as any).dispatchEvent(
              new CustomEvent("korra-file-name", {
                detail: getVideoSectionResponse?.data[0]?._source?.srcUrl
                  ?.split("/")
                  .pop(),
              })
            );
          }

          if (
            getVideoSectionResponse.data[0]._source.srcUrl.startsWith("http")
          ) {
            getVideoSectionResponse.data[0]._source.srcUrl =
              getVideoSectionResponse?.data[0]._source.srcUrl
                .replace(
                  "https://1425625160.rsc.cdn77.org//assistants",
                  get_CDN_BASE_URL()
                )
                .replace(
                  "https://prod-storage-eue5bvbhcbe5ageh.z02.azurefd.net/",
                  getCdnKorraBaseUrl()
                )
                .replace("/assistants/", "");
          } else if (
            getVideoSectionResponse.data[0]._source.srcUrl.startsWith("/")
          ) {
            getVideoSectionResponse.data[0]._source.srcUrl =
              get_CDN_BASE_URL() +
              getVideoSectionResponse.data[0]._source.srcUrl;
          } else {
            getVideoSectionResponse.data[0]._source.srcUrl =
              get_CDN_BASE_URL() +
              "/" +
              getVideoSectionResponse.data[0]._source.srcUrl;
          }
          getVideoSectionResponse.data[0]._source.srcUrl = getVideoSectionResponse.data[0]._source.srcUrl.replace("/datadrive/localCDN", "");
          // remove any double slashes in the URL path
          getVideoSectionResponse.data[0]._source.srcUrl = removeMultipleSlashes(getVideoSectionResponse.data[0]._source.srcUrl);
          setSection(getVideoSectionResponse?.data[0]?._source);
        })
      )
      .catch((errors: any) => {
        // react on errors.
        logger.error({
          message: "Problem in fetching video source and section",
          error: errors,
          stacktrace: errors?.stack,
          portal_alias: alias.portalAlias,
          workspace_id: workspaceid || companyid,
          kapp_id: kappid,
          doc_guid: docguid,
          guid: guid,
          video_section_url: getVideoSectionUrl,
          video_source_url: getVideoSourceUrl
        });
      });
    // get text in parallel
    const getVideoTextUrl =
      get_AI_URI_BASE() +
      `/api/getVideoText/company/${
        companyid || workspaceid
      }/kapp/${kappid}/video/${docguid}`;
    axios
      .get(getVideoTextUrl, headers)
      .then((textResponse: any) => {
        setVideoText(textResponse.data);
      })
      .catch((error: any) => {
        // react on errors.
        logger.error({
          message: "Problem in fetching video text",
          error: error,
          stacktrace: error?.stack,
          portal_alias: alias.portalAlias,
          workspace_id: workspaceid || companyid,
          kapp_id: kappid,
          doc_guid: docguid,
          video_text_url: getVideoTextUrl
        });
      });
    sendEvent(
      companyid || workspaceid,
      kappid,
      portalid || "",
      alias.portalAlias || "",
      globals.sessionId || "",
      IKorraEventType.videoPlay,
      window.navigator.userAgent,
      isMobileOnly ? `mobile` : `desktop`,
      userId || "",
      {
        question: "",
        answerText: section?.text,
        answerLink: document.URL,
        fileName: section?.srcUrl,
        fileType: FileType.Video,
      } as IKorraEventDoc,
      globals.clientIp || ""
    );
  }, [workspaceid, companyid, kappid, guid, docguid]);

  useEffect(() => {
    if (videoText) {
      const intervalId = setInterval(() => {
        if (videoRef?.current?.currentTime) {
          const currentSubtitle = videoText.subtitles.find(
            (s: ISubtitle) =>
              (videoRef?.current?.currentTime as number) >= s.t0 &&
              (videoRef?.current?.currentTime as number) <= s.t1
          );
          if (currentSubtitle) {
            let el = document.getElementById("current-text");
            if (el) {
              if (currentSubtitle.text) {
                el.innerHTML = currentSubtitle.text;
                el.style.display = subtitles ? "block" : "none";
              } else {
                el.innerHTML = "";
                el.style.display = "none";
              }
            }
            return; // no need to change guid. it creates a problem when refreshing the page
          }
        }
      }, 500);

      return () => {
        clearInterval(intervalId);
      };
    }
  }, [videoText]);

  return (
    <Fragment>
      <div
        id="current-text"
        className={isMobileOnly ? style.subtitleMobile : style.subtitle}
        style={{ display: "none", position: "absolute", zIndex: 9999999 }}
      ></div>
      {section &&
      (section.srcUrl?.split(".").pop() == "mp4" ||
        section.srcUrl?.split(".").pop() == "m3u8") ? (
        (isIOS || getIsEdge()) ? (
          <video
            ref={videoRef}
            autoPlay={false}
            style={{ marginTop: "48px" }}
            controls={controls}
            className={style.video}
            muted={muted}
            controlsList="nodownload"
          >
            <source
              src={
                section.srcUrl?.split(".").pop() == "mp4"
                  ? SassToken
                    ? getIsEdge() ?`${section.srcUrl}?sasToken=${SassToken}`: `${section.srcUrl}?${SassToken}`
                    : `${section.srcUrl}`
                  : `${section.srcUrl.replace(
                      get_CDN_BASE_URL(),
                      `${get_AI_URI_BASE()}/hls_proxy`
                    )}${SassToken ? "?" + SassToken : ""}`
              }
              type={
                section.srcUrl?.split(".").pop() == "mp4"
                  ? "video/mp4"
                  : "application/x-mpegURL"
              }
            />
            Your browser does not support the video tag.
          </video>
        ) : (
          <ReactHlsPlayer
            playerRef={videoRef}
            className={style.video}
            src={
              section.srcUrl?.split(".").pop() == "mp4"
                ? SassToken
                  ? getIsEdge() ? `${section.srcUrl}?sasToken=${SassToken}`:`${section.srcUrl}?${SassToken}`
                  : `${section.srcUrl}`
                : SassToken
                ? `${section.srcUrl}?${SassToken}`
                : `${section.srcUrl}`
            }
            autoPlay={false}
            controls={false}
            // controls={controls}
            handleToggleFullScreen={handleToggleFullScreen}
            muted={muted}
            isMobile={isMobile}
            hlsConfig={
              SassToken
                ? {
                    // !isCDN77 ?
                    debug: true,
                    enableWorker: true,
                    lowLatencyMode: true,
                    xhrSetup: function (xhr: XMLHttpRequest, url: string) {
                      /*
                   const urlWithSass = url.includes(".ts")
                     ? url:
                     url.includes("video.m3u8")
                     ? (url + "?" + SassToken).replace(
                         "https://prod-storage-eue5bvbhcbe5ageh.z02.azurefd.net",
                         "http://localhost:8000"
                       )
                     : url.replace(
                         "https://prod-storage-eue5bvbhcbe5ageh.z02.azurefd.net",
                         "http://localhost:8000"
                       );
                    **/

                      const urlWithSass = url.includes("?") ? url : `${url}?${SassToken}`;

                      logger.log({
                        message: "HLS xhrSetup configuration",
                        portal_alias: alias.portalAlias,
                        workspace_id: workspaceid || companyid,
                        kapp_id: kappid,
                        doc_guid: docguid,
                        url: urlWithSass
                      });
                      xhr.open("GET", urlWithSass, true);
                    },
                  }
                : {
                    debug: true,
                    enableWorker: true,
                    lowLatencyMode: true,
                    backBufferLength: 90,
                  }
            }
          />
        ) // )
      ) : section && SassToken ? (
        <ReactHlsPlayer
          playerRef={videoRef}
          className={style.video}
          src={
            isIOS
              ? `${section.srcUrl.replace(
                  get_CDN_BASE_URL(),
                  `${get_AI_URI_BASE()}/hls_proxy`
                )}?${SassToken}`
              : `${section.srcUrl}?${SassToken}`
          }
          autoPlay={false}
          controls={false}
          // controls={controls}
          handleToggleFullScreen={handleToggleFullScreen}
          muted={muted}
          hlsConfig={
            SassToken
              ? {
                  // !isCDN77 ?
                  debug: true,
                  enableWorker: true,
                  lowLatencyMode: true,
                  xhrSetup: function (xhr: XMLHttpRequest, url: string) {
                    /*
                    const urlWithSass = url.includes(".ts")
                      ? url:
                      url.includes("video.m3u8")
                      ? (url + "?" + SassToken).replace(
                          "https://prod-storage-eue5bvbhcbe5ageh.z02.azurefd.net",
                          "http://localhost:8000"
                        )
                      : url.replace(
                          "https://prod-storage-eue5bvbhcbe5ageh.z02.azurefd.net",
                          "http://localhost:8000"
                        );
                     **/

                    const urlWithSass = url.includes("?") ? url : `${url}${SassToken}`;

                    logger.log({
                      message: "HLS xhrSetup configuration (fallback player)",
                      portal_alias: alias.portalAlias,
                      workspace_id: workspaceid || companyid,
                      kapp_id: kappid,
                      doc_guid: docguid,
                      url: urlWithSass
                    });
                    xhr.open("GET", urlWithSass, true);
                  },
                }
              : {
                  debug: true,
                  enableWorker: true,
                  lowLatencyMode: true,
                  backBufferLength: 90,
                }
          }
        />
      ) : null}
    </Fragment>
  );
};

export default KorraVideoPlayer;
